'use client';

import { useState, useCallback } from 'react';

interface Props {
  prompt: string;
}

export function AgentPromptView({ prompt }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(prompt);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for environments without clipboard API
      const textarea = document.createElement('textarea');
      textarea.value = prompt;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [prompt]);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h3 className="text-text-primary text-sm font-semibold">
          Agent Prompt
        </h3>
        <button
          type="button"
          onClick={handleCopy}
          className={`rounded px-3 py-1 text-xs font-medium transition-all ${
            copied
              ? 'bg-positive/20 text-positive'
              : 'bg-surface-2 text-text-secondary hover:text-text-primary'
          }`}
        >
          {copied ? 'Copied!' : 'Copy to Clipboard'}
        </button>
      </div>

      <pre className="bg-surface-card border-stroke overflow-x-auto overflow-y-auto rounded-lg border p-3 font-mono text-xs leading-relaxed text-green-400 max-h-[320px]">
        {prompt}
      </pre>

      <p className="text-text-tertiary text-xs">
        Paste this into Claude Code or another AI agent to begin debugging.
      </p>
    </div>
  );
}
